import createApi from 'services/api';

export default createApi({
  baseUrl: 'reports',
  headers: {
    'Content-Type': 'application/json'
  },
});
